<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>بنود الصلاحيات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع بنود الصلاحيات
                                <div v-show="$per.value.savePermission" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                <h4 >الادارة:</h4>
                                <select @change='changeDepartment($event.target.value)' class="form-control" style="padding: 0px" v-model="department">
                                  <option v-for="department in departments" v-bind:key="department.id" v-bind:value="department.id">
                                    {{ department.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                <h4 >الصفحة:</h4>
                                <select @change='GetData($event.target.value)' class="form-control" style="padding: 0px" v-model="page">
                                  <option v-for="page in pages" v-bind:key="page.id" v-bind:value="page.permissions_group">
                                    {{ page.permissions_group }}
                                  </option>
                                </select>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الصفحة</th>
                                          <th style='text-align: center'>الصلاحية</th>
                                          <th style='text-align: center'>الاسم</th>
                                          <th style='text-align: center'>الوصف</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.permissions_group}}</td>
                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.display_name}}</td>
                                          <td align='center'>{{record.description}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deletePermission" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editPermission" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                             <div class='col-lg-6 col-sm-6'>
                                 <label>الادارة:</label>
                                 <select class="form-control" style="padding: 0px" v-model="record.department_name">
                                   <option v-for="department in departments" v-bind:key="department.id" v-bind:value="department.id">
                                     {{ department.name }}
                                   </option>
                                 </select>
                             </div>

                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الصفحة:</label>
                                     <input v-model='record.permissions_group' class='form-control' name='permissions_group' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>اسم الصلاحية <code>بالانجليزية</code>:</label>
                                     <input v-model='record.name' class='form-control' name='name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>اسم الصلاحية المعروض:</label>
                                     <input v-model='record.display_name' class='form-control' name='display_name' type='text'>
                                 </div>
                                 <div class='form-group col-lg-12 col-sm-12'>
                                     <label>الوصف:</label>
                                     <input v-model='record.description' class='form-control' name='description' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'permission',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      pages: {},
      page: '',
      departments: {},
      department: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  created () {
    this.GetDepartments()
  },
  methods: {
    GetDepartments () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPermissionPages', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.departments = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    changeDepartment (id) {
      this.page = ''
      let i = this.departments.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.pages = this.departments[i].permission_pages
      }
    },
    GetData (id) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPermission', {
        token: localStorage.getItem('token'),
        permissions_group: id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'department_name': '', 'permissions_group': '', 'name': '', 'display_name': '', 'description': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'department_name': recID.department_name, 'permissions_group': recID.permissions_group, 'name': recID.name, 'display_name': recID.display_name, 'description': recID.description}
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'savePermission', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        department_name: this.record.department_name,
        permissions_group: this.record.permissions_group,
        name: this.record.name,
        display_name: this.record.display_name,
        description: this.record.description
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deletePermission', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/PermissionItems.vue